import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  tenantPreference: generateApiPath({ prefix: AuthLevel.ADMIN, name: 'tenant-preference' }),
}

export { paths }
